import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import {
  useCreateDepartmentReviewMutation,
  useUpdateDepartmentReviewMutation,
} from 'store/services/departments/Review';
import { message } from 'style-guide/ToastMessages';
import ReviewModal from './ReviewModal';

const DepartmentReviewModal = ({ params, hideModal }) => {
  const [createReview, { isSuccess, isError }] = useCreateDepartmentReviewMutation();
  const [updateReview, { isSuccess: isUpdateSuccess, isError: isUpdateError }] = useUpdateDepartmentReviewMutation();

  const { urlName, reviewId, comment, rating: currentRating, id, libraryId } = params;

  const { control, handleSubmit, watch } = useForm({
    defaultValues: {
      comment: comment || '',
      rating: currentRating,
    },
  });
  const rating = watch('rating');

  const onFormSubmit = handleSubmit((formData) => {
    if (currentRating) {
      return updateReview({ reviewId, urlName, id, ...formData });
    }
    createReview({ libraryId, urlName, ...formData });
  });

  useEffect(() => {
    if (isSuccess || isUpdateSuccess) {
      message.success(`Review successfully has been ${isUpdateSuccess ? 'updated' : 'created'}`);
      hideModal();
    }
    if (isError || isUpdateError) {
      message.error('Something went wrong!');
    }
  }, [isSuccess, isError, hideModal, isUpdateSuccess, isUpdateError]);

  return <ReviewModal onFormSubmit={onFormSubmit} control={control} disabled={!rating} hideModal={hideModal} />;
};

export default DepartmentReviewModal;
